import React from 'react';
import { FormControl, TextField, FormHelperText, TextFieldProps } from '@mui/material';
import { useTheme } from "@mui/material/styles";

const CustomTextField: React.FC<TextFieldProps> = ({
	error,
	label,
	value,
	onChange,
	InputLabelProps,
	InputProps,
	sx,
	helperText,
	type = 'text',
	onKeyDown,
	...rest
}) => {
		const theme= useTheme();
	return (
		<FormControl fullWidth error={error} className={rest.className ? 'wrapper-' + rest.className : ''}>
			<TextField
				label={label}
				value={value}
				onChange={onChange}
				onKeyDown={onKeyDown}
				error={error}
				type={type}
				FormHelperTextProps={{ sx: { color: 'red' } }}
				InputLabelProps={{
					sx: {
						backgroundColor: 'primary.darker',
						padding: '0 6px',
						...InputLabelProps?.sx
					},
					...InputLabelProps
				}}
				InputProps={{
					...InputProps,
				
					sx: {
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: 'white.main',
							borderWidth: '1px',
							borderStyle: 'solid'
						},
						'&:hover .MuiOutlinedInput-notchedOutline': {
							borderColor: 'white.main'
						},
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderColor: 'white.main'
						},
						'& .MuiInputBase-input::placeholder': {
							...theme.typography.filterText,
						},
						...InputProps?.sx
					},
				}}
				sx={{
					'& .MuiOutlinedInput-root': {
						border: '1px solid white.main'
					},
					'& .MuiInputBase-input.Mui-disabled': {
						WebkitTextFillColor: 'light.diff'
					},
					...sx
				}}
				{...rest}
			/>
			<FormHelperText sx={{ color: 'red' }}>{error && helperText}</FormHelperText>
		</FormControl>
	);
};

export default CustomTextField;
